module.exports = __webpack_public_path__ + "static/media/UN-16.00f6d310.jpg";